/**
 * Service for position export operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import type { PositionsExportFilters } from '../types';


export class PositionExportService {
  async export(filters?: PositionsExportFilters)
    : Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    const queryString = buildQueryString(filters ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.ORGANIZATION.EXPORT_POSITIONS}${queryString}`;

    const response = await apiClient.downloadBlobWithFilename(endpoint, {
      method: 'GET',
    });

    if (response.success && response.data) {
      return response;
    }

    return { ...response, data: null };
  }
}

export const positionExport = new PositionExportService();
